/*
 * Mixins and values meant for control components:
 * Buttons, Chip, Dropdown, Select, FormInput, etc
 *
 * TODO: Migrate things off of legacy sizes (sm, md, lg)
 * and delete the references here
 */

import { spacer4, spacer8, spacer12, spacer32, spacer48, spacer56 } from '@spotify-internal/encore-foundation';
export var controlSizes = ['small', 'medium', 'large'];
export var controlSizesLegacy = ['sm', 'md', 'lg'];
export var getNextControlSize = function getNextControlSize(sizeName) {
  var controlSizesMap = {
    sm: 'small',
    md: 'medium',
    lg: 'large'
  };
  return controlSizesMap[sizeName];
};
export var controlMinBlockSize = {
  small: spacer32,
  medium: spacer48,
  large: spacer56,
  sm: spacer32,
  md: spacer48,
  lg: spacer56
};
export var controlPaddingBlock = {
  small: spacer4,
  medium: spacer8,
  large: spacer12,
  sm: spacer4,
  md: spacer8,
  lg: spacer12
};
export var controlIconSize = {
  small: 'small',
  medium: 'medium',
  large: 'medium'
};
export var controlGraphicSize = {
  small: 'smaller',
  medium: 'base',
  large: 'base'
};